import NiotaClassicApiService from '@/services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import map from 'lodash/map';
import find from 'lodash/find';
export default {
  name: 'NiotaClassicDevicesAddAdd',
  mixins: [formMixin],
  props: {
    device: {
      type: Object,
      required: false,
      default: null
    },
    originator: {
      type: Object,
      required: false,
      default: null
    },
    deviceTypes: {
      type: Array,
      required: false,
      default: new Array()
    },
    applicationId: {
      type: Number,
      required: false,
      default: null
    },
    datasourceType: {
      type: String,
      required: false,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      deviceObject: null,
      euis: null,
      originatorDevices: [],
      showDevices: false,
      selectedItems: [],
      errors: [],
      allSelected: false,
      deviceTypeId: null,
      error: false,
      loading: false,
      tabItem: 'add-new-device'
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    createPossible() {
      if (this.datasourceType === 'firefly_mqtt' || this.datasourceType === 'firefly' || this.datasourceType === 'udp' || this.datasourceType === 'actility' || this.datasourceType === 'webhook' || this.datasourceType === 'filesystem') {
        return true;
      }
      return false;
    }
  },
  watch: {},
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.deviceObject = cloneDeep(this.device);
      this.fetchOriginatorDevices();
    },
    fetchOriginatorDevices() {
      this.loading = true;
      NiotaClassicApiService.originatorsGetDevices(this.originator.id).then(res => {
        this.originatorDevices = res.data.devices;
      }).catch(error => {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.infoFindingOriginatorDevices'), 'info');
        console.error(error);
      }).finally(() => this.loading = false);
    },
    fetchDeviceInfoFromSource() {
      NiotaClassicApiService.applicationsFetchDeviceInfoFromSource(this.originator).then(res => {
        this.checkForError(res.euis);
      }).catch(error => {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.infoFindingOriginatorDevices'), 'info');
        console.error(error);
      });
    },
    devicesCreate() {
      this.loading = true;
      return NiotaClassicApiService.devicesCreate(this.selectedItems).then(res => {
        if (!res.err) {
          this.error = false;
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.deviceUpdated'), 'success');
        } else if (res.data.err) {
          this.error = true;
          this.$snack(res.data.err, 'error');
        } else {
          this.error = true;
          this.$snack(res.err, 'error');
        }
      }).catch(error => {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.deviceUpdateFaild'), 'error');
        console.error(error);
      }).finally(() => {
        this.loading = true;
      });
    },
    selectItem(item, key) {
      if (this.originatorDevices[key].selected) {
        this.originatorDevices[key].selected = !this.originatorDevices[key].selected;
        this.selectedItems = filter(this.selectedItems, device => device.eui !== item.eui);
      } else {
        this.originatorDevices[key].selected = true;
        let index = find(this.selectedItems, device => device.eui === item.eui);
        if (!index) {
          this.selectedItems.push(item);
        }
      }
    },
    searchDevices() {
      if (this.euis) {
        this.originator.euis = this.euis.trim();
        this.originator.applicationId = this.applicationId;
        this.fetchDeviceInfoFromSource();
      }
    },
    updateSelectedList(item) {
      this.selectedItems = filter(this.selectedItems, device => device.eui !== item.eui);
      this.errors = filter(this.selectedItems, device => !device.valid && device.errorMessage);
      this.originatorDevices = map(this.originatorDevices, device => {
        if (device.eui === item.eui) {
          delete device.selected;
        }
        return device;
      });
      if (!this.selectedItems.length) {
        this.allSelected = false;
      }
    },
    checkForError(euis) {
      euis.forEach(eui => {
        if (!eui.valid && eui.errorMessage) {
          this.errors.push(eui);
        }
        let index = find(this.selectedItems, device => device.eui === eui.eui);
        if (!index) {
          this.selectedItems.push(eui);
        }
      });
    },
    async addItem() {
      if (this.selectedItems.length) {
        this.assignData();
        await this.devicesCreate();
      }
      if (!this.error) {
        this.$emit('refreshList');
        this.$emit('close');
      }
    },
    selectAllDevices(select) {
      this.originatorDevices = map(this.originatorDevices, device => {
        if (select) {
          device.selected = select;
          let result = find(this.selectedItems, item => item.eui === device.eui);
          if (!result) {
            this.selectedItems.push(device);
          }
          this.allSelected = true;
        } else {
          delete device.selected;
          this.selectedItems = [];
          this.allSelected = false;
        }
        return device;
      });
    },
    setDeviceTypeId(deviceTypeId) {
      this.deviceTypeId = deviceTypeId;
    },
    setOperationalStatus(status) {
      this.operationalStatus = status;
    },
    assignData() {
      this.selectedItems = map(this.selectedItems, item => {
        // if (this.datasourceType === 'firefly_mqtt' || this.datasourceType === 'firefly') {
        return this.newDevice(item);
        // }
      });
    },
    newDevice(device) {
      if (device.lorawan_device) {
        device.adr_limit = device.lorawan_device.adr_limit;
      }
      let properties = {
        operational_status: this.operationalStatus
      };
      return {
        valid: true,
        add: true,
        name: device.name,
        lorawan_device: {
          nwk_s_key: device.network_session_key,
          dev_addr: device.address,
          app_s_key: device.application_session_key,
          app_key: device.application_key,
          adr_limit: device.adr_limit
        },
        eui: device.eui,
        description: device.description,
        applicationId: this.applicationId,
        originatorId: this.originator.id,
        deviceTypeId: this.deviceTypeId,
        properties,
        externalId: device.ref
      };
    },
    addNewItem() {
      this.$emit('addNewItem');
    }
  }
};